import { render, staticRenderFns } from "./DeanAdmissionsDocumentsStudentWrapper.vue?vue&type=template&id=34a59294"
import script from "./DeanAdmissionsDocumentsStudentWrapper.vue?vue&type=script&lang=js"
export * from "./DeanAdmissionsDocumentsStudentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports